import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MentoringMenteesComponent } from '@app/mentoring/components/mentoring/mentoring-mentees/mentoring-mentees.component';
import { MentoringMentorsComponent } from '@app/mentoring/components/mentoring/mentoring-mentors/mentoring-mentors.component';
import { SharedModule } from '@app/shared/shared.module';
import { TagsModule } from '@app/tags/tags.module';
import { DfFormlyModule } from '@lib/fresco';
import { MentoringComponent } from './components/mentoring/mentoring.component';
import { ConnectWithMentorModalComponent } from './components/modals/connect-with-mentor-modal/connect-with-mentor-modal.component';
import { GiveFeedbackModalComponent } from './components/modals/give-feedback-modal/give-feedback-modal.component';
import { AcceptMenteeModalComponent } from './components/modals/mentee-modals/accept-mentee-modal/accept-mentee-modal.component';
import { BaseMenteeModalComponent } from './components/modals/mentee-modals/base-mentee-modal/base-mentee-modal.component';
import { MoreDetailsMenteeModalComponent } from './components/modals/more-details-modal/more-details-modal.component';
import { RejectMenteeModalComponent } from './components/modals/mentee-modals/reject-mentee-modal/reject-mentee-modal.component';
import { ReviewMentorshipModalComponent } from './components/modals/review-mentorship-modal/review-mentorship-modal.component';
import { PeerRatingModalComponent } from './components/modals/peer-rating-modal/peer-rating-modal.component';
import { UserCardSkillsModalComponent } from './components/modals/user-card-skills-modal/user-card-skills-modal.component';
import { MentoringSharedModule } from './mentoring-shared.module';
import { MentoringBadgePipe } from './pipes/mentoring-badge.pipe';
import { MentoringContactPipe } from './pipes/mentoring-contact.pipe';
import { MentoringModalsService } from './services/mentoring-modals.service';

@NgModule({
  declarations: [
    ConnectWithMentorModalComponent,
    MentoringComponent,
    MentoringMenteesComponent,
    MentoringMentorsComponent,
    MentoringBadgePipe,
    MentoringContactPipe,
    BaseMenteeModalComponent,
    AcceptMenteeModalComponent,
    RejectMenteeModalComponent,
    MoreDetailsMenteeModalComponent,
    UserCardSkillsModalComponent,
    ReviewMentorshipModalComponent,
    PeerRatingModalComponent,
    GiveFeedbackModalComponent,
  ],
  exports: [ConnectWithMentorModalComponent, MentoringComponent],
  providers: [MentoringModalsService],
  imports: [
    MentoringSharedModule,
    CommonModule,
    TagsModule,
    SharedModule,
    DfFormlyModule.forRoot(),
  ],
})
export class MentoringModule {}
